import { toast } from 'react-toastify';

import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';
import { getOrganizationSystemAdmin } from '../../../../../helpers/system-admin';

import { API_SUBSCRIBER_ORGANIZATION_USER_UPDATE, ORG_USER_ROLES } from '../../../../../constants';

import { setIsLoading, setIsWaiting, setShowEditPopup } from '../../../../../actions/general';

export const API_SYSTEM_ADMIN_ORGANIZATION_DETAIL = 'organization/:id';
export const ADD_ADMIN_ORGANIZATION_DETAIL = 'addAdminOrganization';

export const addAdminOrganizationDetail = (organization) => {
     return {
          type: ADD_ADMIN_ORGANIZATION_DETAIL,
          payload: organization,
     };
};

export const fetchAdminOrganizationDetailRequest = (organizationId) => async (dispatch) => {
     dispatch(setIsLoading(true));

     try {
          const response = await callApi(API_SYSTEM_ADMIN_ORGANIZATION_DETAIL.replace(':id', organizationId), 'GET');

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const organization = getOrganizationSystemAdmin(response.data);
          dispatch(addAdminOrganizationDetail(organization));
     } catch (error) {
          console.error(error);
     } finally {
          dispatch(setIsLoading(false));
     }
};

export const changeOwnerRequest = (organizationId, payload) => (dispatch, getState) => {
     const organization = getState().admin.organization;

     dispatch(setIsWaiting(true));
     callApi(API_SUBSCRIBER_ORGANIZATION_USER_UPDATE.replace(':organizationId', organizationId), 'PUT', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const data = response.data;
               if (!data) return;

               let hasDataChange = false;

               if (data.updatedNewOwner.user?.email) {
                    hasDataChange = true;
                    organization.ownerEmail = data.updatedNewOwner.user?.email;
               }

               organization?.users?.forEach((user) => {
                    if (user.id === data.currentOwner.userId) {
                         hasDataChange = true;
                         user.orgRole = ORG_USER_ROLES.MANAGER;
                    }

                    if (user.id === data.updatedNewOwner.userId) {
                         hasDataChange = true;
                         user.orgRole = ORG_USER_ROLES.OWNER;
                    }
               });

               if (hasDataChange) {
                    dispatch(addAdminOrganizationDetail(organization));
               }

               toast.success('Change owner successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowEditPopup(null));
          });
};
